// /src/stores/tenantStore.js
import { defineStore } from "pinia"
import { ref, computed } from "vue"
import publicApi from "@/auth/publicApi"

export const useTenantStore = defineStore("tenant", () => {
  const tenant = ref(null)

  async function loadTenant() {
    try {
      const response = await publicApi.get("/Tenants/current")
      tenant.value = response.data
      console.log(tenant.value)
    } catch (error) {
      console.error("Failed to load tenant:", error)
    }
  }

  const subscriptionStatus = computed(() => tenant.value?.subscriptionStatus)
  const planId = computed(() => tenant.value?.planId)
  const nextBillingDate = computed(() => tenant.value?.nextBillingDate)

  return {
    tenant,
    loadTenant,
    subscriptionStatus,
    planId,
    nextBillingDate
    
  }
})